import { render, staticRenderFns } from "./Chapter1_1.vue?vue&type=template&id=14013020&scoped=true&"
import script from "./Chapter1_1.vue?vue&type=script&lang=js&"
export * from "./Chapter1_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14013020",
  null
  
)

export default component.exports